import { notification } from "antd";

type NotificationType = "success" | "error" | "warning" | "info";

/** Avoid dozens of identical toasts when many requests fail (offline, server down, ERR_INSUFFICIENT_RESOURCES). */
let lastNetworkErrorToastAt = 0;
const NETWORK_ERROR_TOAST_COOLDOWN_MS = 10_000;

export function notifyNetworkErrorThrottled(): void {
  const now = Date.now();
  if (now - lastNetworkErrorToastAt < NETWORK_ERROR_TOAST_COOLDOWN_MS) {
    return;
  }
  lastNetworkErrorToastAt = now;
  notification.error({
    message: "Network Error",
    description:
      "Unable to connect to the server. Please check your internet connection.",
    showProgress: true,
    placement: "topRight",
  });
}

/** When many requests hit 5xx at once, show one toast instead of a wall of errors. */
let lastServerErrorToastAt = 0;
const SERVER_ERROR_TOAST_COOLDOWN_MS = 10_000;

export function notifyServerErrorThrottled(): void {
  const now = Date.now();
  if (now - lastServerErrorToastAt < SERVER_ERROR_TOAST_COOLDOWN_MS) {
    return;
  }
  lastServerErrorToastAt = now;
  notification.error({
    message: "Server error",
    description:
      "Please try again in a moment. If this continues, contact support.",
    showProgress: true,
    placement: "topRight",
  });
}

export const notify = {
  success(message?: string, description?: string) {
    notification.success({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  warning(message?: string, description?: string) {
    notification.warning({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  info(message?: string, description?: string) {
    notification.info({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  error(message?: string, description?: string) {
    notification.error({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  toast(
    message?: string,
    variant: NotificationType = "info",
    description?: string
  ) {
    notification[variant]({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
};
